// extracted by mini-css-extract-plugin
export var alignSelf = "quickLinks-module--alignSelf--5Vgsw";
export var quickLink = "quickLinks-module--quickLink--VbyaT";
export var quickLinks = "quickLinks-module--quickLinks--ixyw-";
export var tiles = "quickLinks-module--tiles--gqNAw";